import EvaluateResult from "../../../EvaluateResult"
import { DecisionReason, InAppMessageContextMessage } from "../../../../model/model"

export interface InAppMessageLayoutEvaluateResult extends EvaluateResult {
  message: InAppMessageContextMessage
}

class DefaultInAppMessageLayoutEvaluateResult implements InAppMessageLayoutEvaluateResult {
  constructor(readonly reason: DecisionReason, readonly message: InAppMessageContextMessage) {}
}

// Merged with the interface above so `InAppMessageLayoutEvaluateResult.of(...)` works as a value.
export const InAppMessageLayoutEvaluateResult = {
  of(reason: DecisionReason, message: InAppMessageContextMessage): InAppMessageLayoutEvaluateResult {
    return new DefaultInAppMessageLayoutEvaluateResult(reason, message)
  }
}
